import { makeStyles } from "@material-ui/core";
import styled from "styled-components";

import { theme } from "../../../themes/themes";
export const GeneralStyle = styled.div`
  width: ${({ showCards }) => (showCards ? "96%" : "100%")};
  margin-left: 0;
  margin-top: 2%;
  .MuiIconButton-colorInherit {
    border-radius: 0px;
    margin-right: 0px;
    padding: 0px;
    height: 1.7em;
  }
  .MuiIcon-colorPrimary {
    color: ${({ theme }) => theme.primary.purple};
    border: 1px solid ${({ theme }) => theme.neutral.gray[400]};
    width: 1.7em;
    height: 1.7em;
    font-size: 1em;
    display: flex;
    align-items: center;
    justify-content: center;
    border-right: none;
  }
  .MuiIcon-colorSecondary {
    color: ${({ theme }) => theme.text.primary};
    border: 1px solid ${({ theme }) => theme.neutral.gray[400]};
    width: 1.7em;
    height: 1.7em;
    font-size: 1em;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .MuiPaper-root {
    background-color: ${({ theme }) => theme.background.light};
    box-shadow: none;
  }
  .MuiTableCell-alignLeft {
    text-align: center;
  }
  .MuiTableCell-alignRight {
    text-align: center;
  }
  th {
    background-color: ${({ theme }) => theme.neutral.gray[800]} !important;
  }
  tr:nth-child(even) {
    background-color: ${({ theme }) => theme.neutral.gray[200]};
  }
  .MuiPaper-root > .MuiToolbar-root {
    display: none;
  }
`;

export const BoxColor = styled.div`
  width: 3vh;
  max-width: 100px;
  height: 3vh;
  max-height: 100px;
  position: relative;
  border-radius: 50%;
  background: ${({ colorBackground }) => colorBackground};
`;
export const useStyles = makeStyles(() => ({
  active: {
    "& svg": {
      color: theme.button.primary,
    },
    "&:disabled svg": {
      color: theme.neutral.gray[1200],
    },
  },
  delete: {
    color: theme.status.error,
  },
  buttonActive: {
    background: theme.button.primary,
    color: "white",
    height: "29px",
    padding: "3px 10px",
    fontSize: "12px",
  },
  closeModalResumeAnswer: {},
}));
